<template>
  <div v-if="video && videoNim">
    <MediaPlayer
      :cover="video.cover"
      :origUrl="videoNim.origUrl"
      :pauseTime="pauseTime"
      @beforeDestroy="handleBeforeDestroyed"
      @play="handlePlay"
      @pause="handlePause"
      @ended="handleEnded"
    ></MediaPlayer>
  </div>
</template>
<script>
import MediaPlayer from '@/components/business/MediaPlayerVideo'
export default {
  components: {
    MediaPlayer,
  },
  data () {
    return {
      video: null,
      videoNim: null,
      courseId: this.$route.params.courseId,
      viewDuration: 0,
      startTime: 0,
      pauseTime: 0,
    }
  },
  mounted () {
    this.getVideoDetail()
  },
  methods: {
    getVideoDetail () {
      let videoId = this.$route.params.videoId
      this.$store.dispatch('course/getVideo', { videoId }).then(data => {
        this.video = data
        this.$store.commit('course/setCurrentVideo', data)
        // 通过vid获取到网易中存储到视频路径
        this.$store.dispatch('course/getVideoFromNim', { vid: data.vid }).then(res => {
          this.videoNim = res
        })
        this.$store.dispatch('course/getVideoRecord', { courseId: this.courseId, videoId: data.id }).then(res => {
          this.pauseTime = res && res.pauseTime
        })
      })
    },
    handlePlay () {
      this.startTime = Date.now()
    },
    handlePause () {
      this.calcTime()
    },
    handleEnded () {
      this.calcTime()
    },
    calcTime () {
      // 如果开始时间不为0
      if (this.startTime) {
        this.viewDuration += Math.max(0, Date.now() - this.startTime)
        // 清空开始时间点
        this.startTime = 0
      }
    },
    handleBeforeDestroyed (player) {
      this.calcTime()
      if (player && this.viewDuration > 0) {
        let params = {
          pauseTime: Math.floor(player.currentTime() / 1000),
          recordPkid: this.courseId,
          videoId: this.video.id,
          viewDuration: Math.floor(this.viewDuration / 1000),
          platform: 'web',
        }
        this.$store.dispatch('course/addVideoRecord', params)
      }
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
